/**
 * Enum de iconos Lottie disponibles
 * Cada valor corresponde al nombre del archivo .lottie (con extensión)
 * Los archivos están en el CDN de Bunny: https://assets.analiticafantasy.com/lotties/
 */
export const LOTTIE_ICONS = {
    // Status icons
    OK_STATUS: 'ok-status.lottie',
    INJURED_RED: 'injured-red.lottie',
    INJURED_BLACK: 'injured-black.lottie',
    EXTRADEPORTIVO: 'extradeportivo.lottie',
    DOUBT_GREEN: 'doubt-green.lottie',
    DOUBT_ORANGE: 'doubt-orange.lottie',
    RIGHT_ARROW: 'right-arrow.lottie',
    RED_CARD: 'red-card.lottie',
    FIRE: 'fire.lottie',
    MONEY: 'money.lottie',
    MONEY2: 'money2.lottie',
    SOCCER_FIELD: 'soccer-field.lottie',
    SOCCER_GOAL: 'soccer-goal.lottie',
    MARVIN: 'marvin.lottie',
    JARVIS: 'jarvis.lottie',
    CLOWN: 'clown.lottie',
    LOADING: 'loading.lottie',
    CLOUDS: 'weather/clouds.lottie',
    RAIN: 'weather/rain.lottie',
    SNOW: 'weather/snow.lottie',
    SNOWING: 'weather/snowing.lottie',
    SUN_CLOUDS: 'weather/sunny-cloud.lottie',
    SUNNY: 'weather/sunny.lottie',
    WEATHER: 'weather/weather.lottie',
    MIST: 'weather/mist.lottie',
    CHAT: 'chat.lottie',
    ATLETICO: 'equipos/atletico.lottie',
    BARCELONA: 'equipos/barcelona.lottie',
    REAL_MADRID: 'equipos/real-madrid.lottie',
    INFO: 'info.lottie',
    SHARE: 'share.lottie',
    SPINNER1: 'spinners/spinner1.lottie',
    SPINNER2: 'spinners/spinner2.lottie',
    SPINNER3: 'spinners/spinner3.lottie',
    SPINNER4: 'spinners/spinner4.lottie',
    SPINNER5: 'spinners/spinner5.lottie',
    SPINNER6: 'spinners/spinner6.lottie',
    SPINNER7: 'spinners/spinner7.lottie',
    SPINNER8: 'spinners/spinner8.lottie',
    SPINNER9: 'spinners/spinner9.lottie',
    OFFSIDE: 'offside.lottie',
    EURO_UP: 'euro-up.lottie',
    EURO_DOWN: 'euro-down.lottie',
    TOP: 'top.lottie',
};

import { getLottieUrl } from '@/helpers/local-images-helper';

/**
 * Obtiene la URL del archivo .lottie (local o CDN según la configuración)
 * Si NEXT_PUBLIC_USE_LOCAL_IMAGES=true, usa archivos locales desde /assets/lotties/
 * Si no, usa el CDN de Bunny: https://assets.analiticafantasy.com/lotties/
 * @param {string} iconName - Nombre del archivo .lottie (con extensión)
 * @returns {string} URL completa del archivo
 */
export const getLottieIconPath = (iconName) => {
    if (!iconName) return null;
    
    // Usar el helper que decide entre local o CDN
    return getLottieUrl(iconName);
};
